module.exports = __webpack_public_path__ + "img/icon-cardgames-black.aac8bd38.svg";